import { makeStyles, Theme } from '@material-ui/core'

export const useCommentFormStyles = makeStyles((theme: Theme) => ({
  actions: {
    minWidth: theme.breakpoints.values.sm,
  },
}))
